import React from 'react';
import ajaxLoader from 'images/ajax-loader.gif';

function Spinner() {
  return <img src={ajaxLoader} alt="loading" className="loading"/>;
};

export default Spinner;
